import classNames from "classnames";
import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import ATitle from "../components/ATitle";
import useDropdown from "../components/hooks/useDropdown";
import Search from "../components/Search";
import Wrapper from "../components/Wrapper";
import { farmLpt } from "../placeholder";
import { farmDW, farmClaim, ApproveDeposit } from "../redux/actions/modal";
import Timer from "../components/Timer";
import InfoButton from "../partials/Form/InfoButton";
import Hint from "../components/Hint/Hint";
import Form from "../partials/Form";

const Item = ({
  id,
  currencies,
  apr,
  claim,
  farming,
  rewardsCycle,
  earned,
  pid,
  lpToken,
  style = {},
}) => {
  const [ref, styles, open, setOpen] = useDropdown({ speed: 100 });
  const dispatch = useDispatch();
  const [tokenCategory, setTokenCategory] = useState(1);

  return (
    <div
      className={classNames("farm-item", { opened: open })}
      style={style}
      key={id}
    >
      <div className="farm-item__rate">
        <div className="farm-item__rate-wrapper">
          <Hint
            className="trade-item__hint"
            posY="bottom"
            posX="left"
            maxWidth={350}
            edgeCut={5}
            hintContent={'C1'}
          > 
          <span className="farm-item__rate-number">C{1}</span>
           </Hint>
        </div>
      </div>
      <div className="farm-item__content">
        <div className="farm-item__information" onClick={() => setOpen(!open)}>
          <div className="farm-item__col farm-item__col_currency">
            <span className="farm-item__col-title red">Timed Lock Farm</span>
            <span className="farm-item__col-value">
              <img
                src={currencies.icon}
                alt="icon"
                className="farm-item__col-icon"
              />
              <div className="farm-item__col-name">{currencies.name}</div>
            </span>
          </div>
          <div className="farm-item__col farm-item__col_info">
            <div className="farm-info-lpt">
              <span className="farm-info__title">APR</span>
              <span className="farm-info__value">{apr}%</span>
            </div>
            <div className="farm-info-lpt">
              <span className="farm-info__title">Rewards Cycle</span>
              <span className="farm-info__value">{rewardsCycle}</span>
            </div>
            <div className="farm-info-lpt">
              <span className="farm-info__title">Earned rASKO Rewards</span>
              <span className="farm-info__value">{earned}</span>
            </div>
          </div>
          <div className="farm-item__col farm-item__col_btn">
            <button className="farm-item__btn-dropdown">
              <img
                src="/assets/images/page-icons/arrow-dropdown.svg"
                alt="arrow"
              />
            </button>
          </div>
        </div>
        <div ref={ref} style={styles} className="farm-item__dropdown">
          <div className="farm-item__info_main">
            <div className="farm-item__info_timer farm-item__info_timer_hr">
              <h4>
                Time Remaining to Withdraw:
                <Timer expiryTimestamp={new Date().setSeconds(60000)} />
                <span>
                  Time Lock
                  <InfoButton
                    className="recollateralize-info__info-btn"
                    posX="center"
                  ></InfoButton>
                </span>
              </h4>

              <h4>
                Select HR Token Category
                <Form.Input
                  className="form-mod__name form-item__input_number"
                  name="name"
                  type="number"
                  value={tokenCategory}
                  setValue={() => setTokenCategory()}
                  pattern="[0-9]*"
                  min="1"
                />
              </h4>
            </div>
            <div className="farm-item__info_blocks">
              <div className="farm-item__info_block">
                <h6>Risk Token Balance</h6>
                <span>00</span>
              </div>
              <div className="farm-item__info_block">
                <h6>Risk Token Staked</h6>
                <span>00</span>
              </div>
              <div className="farm-item__info_block">
                <h6>Pending Rewards</h6>
                <span>00</span>
              </div>
            </div>
          </div>
          <div className="farm-item__controls">
            <button
              className="farm-item__btn farm-item__btn_farm"
              onClick={() =>
                dispatch(
                  ApproveDeposit({
                    type: "deposit",
                    pid,
                    lpToken,
                    rewardsCycle,
                    farming,
                    img: currencies.icon,
                    name: currencies.name,
                  })
                )
              }
            >
              Deposit/Approve
            </button>
            <button
              className="farm-item__btn farm-item__btn_farm"
              onClick={() =>
                dispatch(
                  farmDW({
                    type: "withdraw",
                    img: currencies.icon,
                    pid,
                    lpToken,
                    farming,
                    name: currencies.name,
                  })
                )
              }
            >
              Withdraw
            </button>

            <button
              className="farm-item__btn farm-item__btn_farm"
              onClick={() => dispatch(farmClaim({ pid, lpToken, claim }))}
            >
              Claim
            </button>
            <button className="farm-item__btn farm-item__btn_farm">
              Reinvest
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function () {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("ASC");

  return (
    <div className="farm">
      <header className="farm__header">
        <ATitle className="farm__title" text="HR TOKEN FARM" />
        <Search
          className="farm__search"
          placeholder="Search"
          name="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </header>
      <div className="farm-list">
        <div className="farm-list__wrapper">
          <Wrapper
            className="farm-list__items custom-scrollbar"
            marginTop={20}
            showItems={5}
          >
            {farmLpt.map((item) => (
              <Item {...item} key={item.id} />
            ))}
          </Wrapper>
        </div>
      </div>
    </div>
  );
}
